import Inset from './inset';

export default Inset;
